<template>
  <div class="space-y-4">
    <h2>{{ t('deposits') }}</h2>
    <MultipleValuesListField
      name="deposits"
      :button-text="t('addDepositStep')"
      :field-settings="fieldSettings"
      show-delete-alert
    />
  </div>
</template>

<script lang="ts" setup>
import MultipleValuesListField, {
  type FieldSettings,
} from '@/components/MultipleValuesListField.vue';
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';

const { t } = useI18n();

const fieldSettings = computed<FieldSettings[]>(() => [
  {
    name: 'netPurchasePriceLt',
    label: t('netPurchasePriceLt'),
    placeholder: '∞',
    type: 'number',
    adornment: '€',
  },
  {
    name: 'deposit',
    label: t('deposit'),
    adornment: 'km',
    type: 'number',
  },
]);
</script>

<i18n lang="json">
{
  "en": {
    "deposits": "Deposits",
    "addDepositStep": "+ Add deposit step",
    "netPurchasePriceLt": "Net purchase price less than",
    "deposit": "Deposit"
  },
  "de": {
    "deposits": "Kautionen",
    "addDepositStep": "+ Kautionsstaffelung hinzufügen",
    "netPurchasePriceLt": "Netto EK kleiner als",
    "deposit": "Kaution"
  },
  "es": {
    "deposits": "Depósitos",
    "addDepositStep": "+ Añadir tramo de depósito",
    "netPurchasePriceLt": "Precio neto de compra inferior a",
    "deposit": "Depósito"
  }
}
</i18n>
